import { ResponsiveBar } from "@nivo/bar";
import WidgetContainer from "./widget-container";
import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createComponentStore } from "easy-peasy";
import TotalLodgingRentPaymentsDashboardModel from "store/models/dashboard/totallodgingrentpayments";
import { ACTION_TYPES } from "store/models/dashboard";
import { Spin } from "antd";

const useStore = createComponentStore(TotalLodgingRentPaymentsDashboardModel);

export default function LodgingRentPayemntChart({ ...props }) {
  const [store, actions] = useStore();

  useEffect(() => {
    actions.fetch();
  }, []);

  return (
    <Spin spinning={store.process === ACTION_TYPES.FETCHING_DATA}>
      <WidgetContainer
        height="40vh"
        title="Lojman Kira Ödemeleri"
        icon={() => <FontAwesomeIcon icon={["fas", "chart-bar"]} />}
      >
        <ResponsiveBar
          data={store.chartData}
          keys={["Ödendi", "Kısmen Ödendi", "Ödenmedi"]}
          indexBy="Ay/Yıl"
          margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
          padding={0.3}
          colors={{ scheme: "nivo" }}
          borderColor="black"
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "Ay/Yıl",
            legendPosition: "middle",
            legendOffset: 32,
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "Toplamlar",
            legendPosition: "middle",
            legendOffset: -40,
          }}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor="black"
          legends={[
            {
              dataFrom: "keys",
              anchor: "bottom-right",
              direction: "column",
              justify: false,
              translateX: 120,
              translateY: 0,
              itemsSpacing: 2,
              itemWidth: 100,
              itemHeight: 20,
              itemDirection: "left-to-right",
              itemOpacity: 0.85,
              symbolSize: 20,
              effects: [
                {
                  on: "hover",
                  style: {
                    itemOpacity: 1,
                  },
                },
              ],
            },
          ]}
          animate={true}
          motionStiffness={90}
          motionDamping={15}
        />
      </WidgetContainer>
    </Spin>
  );
}
